import { CallApi, handleJSONResponse } from "./common";
import { AdminUserListResponse } from "../../../../services/user-admin/types/api/user-list-response";
import { AdminUserDetailsResponse } from "../../../../services/user-admin/types/api/user-details-response";

const callAPI = CallApi("users-admin");

export const listUsers = async (
  next?: string
): Promise<AdminUserListResponse> => {
  const response = await callAPI(
    `/list${next ? `?next=${next}` : ""}`,
    "GET"
  );

  return await handleJSONResponse(response);
};

export const searchUsers = async (
  keyword: string
): Promise<AdminUserListResponse> => {
  const response = await callAPI(
    `/search?keyword=${keyword}`,
    "GET"
  );

  return await handleJSONResponse(response);
};

export const getUserInfo = async (
  userId: string
): Promise<AdminUserDetailsResponse> => {
  const response = await callAPI(`/details/${userId}`, "GET");

  return await handleJSONResponse(response);
};
